import generateID from './generateID';
const defaultMinMax = {
    z: [[]],
    minX: 0,
    minY: 0,
    maxX: 0,
    maxY: 0,
};
const defaultSER = {
    re: defaultMinMax,
    im: defaultMinMax,
};
const defaultQuadrant = {
    rr: defaultMinMax,
};
export function formatSpectrum2D(spectrumData) {
    const { id = generateID(), meta = {}, dependentVariables = [], info = {}, filters = [], zones = [], ...residualSpectrumData } = spectrumData;
    const spectrum = { id, meta, filters };
    spectrum.info = {
        ...{
            nucleus: ['1H', '1H'],
            isFid: false,
            isComplex: false,
            name: info?.name || generateID(),
        },
        ...info,
    };
    spectrum.originalInfo = spectrum.info;
    spectrum.display = {
        isPositiveVisible: true,
        isNegativeVisible: true,
        isVisible: true,
        dimension: 2,
        ...spectrumData.display,
        ...spectrumData.display,
    };
    let { data = dependentVariables[0].components } = spectrumData;
    spectrum.data = {
        ...(spectrum.info.isFid ? defaultSER : defaultQuadrant),
        ...data,
    };
    spectrum.originalData = spectrum.data;
    spectrum.zones = { ...{ values: [], options: {} }, ...zones };
    return { ...residualSpectrumData, ...spectrum };
}
//# sourceMappingURL=formatSpectrum2D.js.map